module.exports = __webpack_public_path__ + "static/2min2mio_badge-e2b0cdeb5b562be3de599453ba476b38.png";